export default __webpack_public_path__ + "assets/c88ac045a36b25d778c2c00cf8f14858.png";